<template>
    <div>
        <multiselect v-model="DisplayValue" :options="options" :multiple="false" placeholder="Select Gender"
            track-by="id" :clear-on-select="false" :show-labels="false" label="name" :preselect-first="false">
        </multiselect>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
    name: 'genderDropdown',
    props: ['modelValue'],
    components: {
        Multiselect,
    },
    data() {
        return {
            options: [
                { id: 'Male', name: 'Male' },
                { id: 'Female', name: 'Female' }, 
                { id: 'Both', name: 'Both' }
            ],
            value: ''
        };
    },
    computed: {
        DisplayValue: {
            get() {
                // Return a safe fallback if both value and modelValue are null
                return this.value || this.modelValue || null;
            },
            set(value) {
                if (value && value.id) {
                    // Assign the value and emit the id if valid
                    this.value = value;
                    this.$emit('update:modelValue', value.id);
                } else {
                    // Handle null/undefined case
                    this.value = null;
                    this.$emit('update:modelValue', null);
                }
            },
        },
    },
    methods: {


    },
    mounted: function () {
    },
}
</script>